export const SplitModuleMock =
  {
  "uid":"59fe4667-40c5-4194-a989-13feda8fbf3b",
  "componentName":"SplitModule",
  "dataSource":"{DEEC6F37-FAAA-4B7D-B14A-35C42E163E5C}",
  "params":{
    "imagePosition":"left"
  },
  "fields":{
    "bodyText":{
      "value":"Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam."
    },
    "eyebrow":{
      "value":"OPTIONAL EYEBROW"
    },
    "title":{
      "value":"Main title here"
    },
    "link1":{
      "value":{
        "href":"F",
        "text":"Optional Primary CTA",
        "linktype":"external",
        "url":"F",
        "anchor":"",
        "target":""
      }
    },
    "link2":{
      "value":{
        "href":"F",
        "text":"Optional Secondary CTA",
        "linktype":"external",
        "url":"F",
        "anchor":"",
        "target":""
      }
    },
    "image":{
      "value":{
        "src":"http://localhost:8085/images/split-module/pic-16-9-generic-image.png",
        "alt":"pic-16-9-generic-image",
        "width":"1029",
        "height":"579"
      }
    },
    "videoHeading":{
      "value":"Title Lorem Ipsum"
    },
    "videoSubHeading":{
      "value":"Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo inventore veritatis e"
    },
    "imageMobile":{
      "value":{
        "src":"http://localhost:8085/images/split-module/pic-16-9-generic-image-2.png",
        "alt":"pic-16-9-generic-image",
        "width":"832",
        "height":"468"
      }
    },
    "video":{
      "value":{
        "href":"//localhost:8085/videos/HeroCarousel_0.mp4",
        linktype: '',
        target: '',
        id: ''
      }
    },
    "useVideo":{
      "value":false
    }
  }
}
